<template>
  <div>
    <haders></haders>
    <router-view></router-view>
    <foorers></foorers>
  </div>

</template>

<script>
import haders from '@/components/headers.vue'
import foorers from '@/components/foorers.vue'
export default {
  data () {
    return {
    }
  },
  components: {
    haders,
    foorers
  },

  computed: {

  }
}
</script>

<style >
*{
  list-style: none;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/main.vue